import { API } from "../api/axios";
const END_POINT= "/appointments";
const END_POINT2= "/appointment";
const END_POINT_notif= "/appointment-notification";
const FILTER_appointment= "/appointment-filter";
 
class RdvClass {
    getRdv(params) {
        return API.get(END_POINT, params);
    }
    refus(id, status) {
        return API.post(`${END_POINT_notif}/${id}?status=${status}`);
    }
    update(id, params) {
        return API.post(`${END_POINT2}/${id}`,params);
    } 
    add(params) {
        return API.post(`${END_POINT2}?is_admin=true`,params);
    } 
    notice(params) {
        return API.get(END_POINT,params);
    }
    filter(params) {
        return API.get(FILTER_appointment,params);
    }
    
}
export default new RdvClass();
